import { type GlobalQueryCache } from "../../public/types/cache";

export const cache: GlobalQueryCache = {}
